import styled from 'styled-components';

import {
  nepal,
  paradigmLightBlue,
  pickledBluewood,
  razzmatazz,
  lima,
} from '@paradigm/design-system/src/colors';

export const LegsTableContainer = styled.div`
  text-align: left;
  background-color: ${pickledBluewood};
  border-radius: 5px;
  width: 100%;
`;

export const Header = styled.p`
  padding: 0.7rem 0.5rem;
  font-size: 1rem;
  margin: 0;
  height: 42px;
`;

export const TableHeader = styled.div`
  border-bottom: 1px solid ${paradigmLightBlue};
  border-top: 1px solid ${paradigmLightBlue};
  color: #fff;
  font-weight: 500;

  & span {
    color: ${paradigmLightBlue};
  }
`;

export const Row = styled.div`
  display: grid;
  height: 42px;
  grid-template-columns: 22px 125px 40px 64px 70px 50px 70px 32px 140px;
  gap: 12px;
  padding: 0 12px;
  > * {
    align-items: center;
    display: flex;
    font-size: 0.8rem;
    color: ${nepal};
  }
`;

export const ColoredAction = styled.span<{ children: 'BUY' | 'SELL' }>`
  color: ${({ children }) => (children === 'SELL' ? razzmatazz : lima)};
  font-weight: 500;
`;

export const QuantityCol = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & > div {
    margin-bottom: 0.02rem;
  }
`;

export const ContractUnitsLabel = styled.div`
  font-size: 0.6rem;
  opacity: 0.8;
`;
